export const RICH_TOOLTIP_CLASS = "rich-tooltip"

export const escapeTooltipHtml = (value: unknown): string =>
  `${value ?? ""}`
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;")

const cleanTooltipValue = (value: unknown): string => `${value ?? ""}`.trim()

export const tooltipTitle = (value: unknown): string | null => {
  const text = cleanTooltipValue(value)

  return text ? `<strong>${escapeTooltipHtml(text)}</strong>` : null
}

export const tooltipText = (value: unknown): string | null => {
  const text = cleanTooltipValue(value)

  return text ? `<p>${escapeTooltipHtml(text)}</p>` : null
}

export const tooltipField = (label: string, value: unknown): string | null => {
  const text = cleanTooltipValue(value)

  return text
    ? `<div><strong>${escapeTooltipHtml(label)}:</strong> ${escapeTooltipHtml(text)}</div>`
    : null
}

export const tooltipList = (label: string, values: unknown[]): string | null => {
  const items = values.map(cleanTooltipValue).filter(Boolean)

  if (!items.length) return null

  return [
    `<div><strong>${escapeTooltipHtml(label)}:</strong></div>`,
    "<ul>",
    ...items.slice(0, 3).map((item) => `<li>${escapeTooltipHtml(item)}</li>`),
    ...(items.length > 3 ? [`<li>… und ${items.length - 3} weitere</li>`] : []),
    "</ul>",
  ].join("")
}

export const buildRichTooltip = (parts: Array<string | null | undefined | false>): string =>
  parts.filter(Boolean).join("")
